import { getContext } from './images.js'
import { ShadowText, levelNumber } from './main.js'
import { ShadowText as ShadowTextMenu } from './scene-menu.js'

let ctx = null
let winStats = {}

function Reset() {
    frame = maxFrame
}

function WinStats(stats) {
    winStats = stats
}

function AnimationFrame(delta) {
    if (!ctx) {
        ctx = getContext()
    }
    ctx.clearRect(0, 0, 64, 64)

    let title = 'YOU WON'
    ShadowText(32 - parseInt((title.length * 5) / 2), 3, title, '#00f100ff', '#00ca00a9')

    bfontjs.DrawText(ctx, 5, 15, `LEVEL ${winStats.levelNumber}`, '#f1f1f1ff', font)
    bfontjs.DrawText(ctx, 5, 22, `TIME LEFT ${parseInt(winStats.levelTimer / 1000)}`, '#f1f1f1ff', font)
    
    let reason = ''
    if (winStats.winReason === 'timer') {
        reason = 'THE HELICOPTER\nSAVED EVERYONE.'
        bfontjs.DrawText(ctx, 5, 32, reason.split('\n')[0], '#f1f1f1ff', font)
        bfontjs.DrawText(ctx, 5, 38, reason.split('\n')[1], '#f1f1f1ff', font)
    } else if (winStats.winReason === 'flamecount') {
        reason = 'YOU\nSAVED EVERYONE!'
        bfontjs.DrawText(ctx, 5, 32, reason.split('\n')[0], '#f1f1f1ff', font)
        bfontjs.DrawText(ctx, 5, 38, reason.split('\n')[1], '#f1f1f1ff', font)

    }

    if (levelNumber < 4) {
        ShadowTextMenu(5, 56, 'NEXT LEVEL', '#fffc40ff', '#303030d9', undefined, eighties)
    } else {
        ShadowTextMenu(5, 56, 'THE END', '#fffc40ff', '#303030d9', undefined, eighties)
    }
}

export { AnimationFrame, Reset, WinStats }